import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { formatDate, formatDateWithTime } from "../../constants/FormateDate";
import { Dialog } from "primereact/dialog";
import { getLead, getLeadType, userLeadAssign } from "../../services/leads";
import { LeadListUpload } from "../../services/bankListUpload";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpaces, replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { getUser } from "../../services/userMasterUser";
import { Calendar } from "primereact/calendar";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";

export default function SuperTelecallerLeadList() {

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  const ds = useRef(null);

  
    const location = useLocation();
    const isFirstRender = useRef(true);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [fileName, setFileName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [displayLeadListUpload, setDisplayLeadListUpload] = useState(false);
  const [displayLeadAssignmentUpload, setDisplayLeadAssignmentUpload] = useState(false);
  const [assignedTelecallerId, setAssignedTelecallerId] = useState("")
  const [assignedLeadId, setAssignedLeadId] = useState("")

  const onClickLeadListUpload = (item) => {
    setDisplayLeadListUpload(true);
  };
  const onHideLeadListUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayLeadListUpload(false);
  };

  const onClickLeadAssignmentUpload = (item) => {
    setAssignedLeadId(item)
    setDisplayLeadAssignmentUpload(true);
  };
  const onHideLeadAssignmentUpload = () => {
    
    setAssignedTelecallerId("");
    setDisplayLeadAssignmentUpload(false);
  };


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    quires: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

   const [startDateValue, setStartDateValue] = useState(null);
    const [endDateValue, setEndDateValue] = useState(null);
  

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const searchByStatusData = [
    { label: "Name", value: "name" },
    { label: "Mobile", value: "mobile" },
    { label: "Quires", value: "quires" },
    { label: "Address", value: "address" },
  ]

   const recordTypeSelection = [
       { label: "CreatedOn", value: "CreatedOn" },
       { label: "LeadOn", value: "LeadOn" }, 
       { label: "FollowUpOn", value: "FollowUpOn" }, 
       { label: "ClosedOn", value: "ClosedOn" }]
   
     const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
     const [leadTypeList, setLeadTypeList] = useState([])
     const [typeOfLead, setTypeOfLead] = useState('')
  

  const [searchByStatus, setSearchByStatus] = useState('name');
  const [selectedTelecallerId, setSelectedTelecallerId] = useState("");
  const [userDataIds, setUserDataIds] = useState([]);
  const [allUserDataIds, setAllUserDataIds] = useState([]);

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: ["RECEIVE"],
    sourceIn: [],

    // recordType: recordTypeValue,
    // startDate: "",
    // endDate: "",
    // leadTypeIn: []

  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);

          if (append) {
            setProducts((prev) => [...(prev || []), ...rawData]);
          } else {
            setProducts(rawData);
          }

          setTotalRecords(response.data.totalRecords || rawData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  const userData = {
    searchBy: "",
    searchText: "",
    limit: 1000,
    offset: 0,
    sortBy: "",
    userTypeIdIn: [],
    roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
    sortOrder: "desc",
    statusIn: [],

  };

  const getUsers = (userData) => {
    getUser(userData)
          .then((response) => {
            if (!response.data.error) {
              const newData = response.data.data || response.data; // adjust if API structure differs
              const newDataId = newData.map(item => item.id);
              const newDataIds = newData.map(item => ({
                label: item.userName + " - " + item?.userTypeInfo, value: item.id 
              }));
              
              setUserDataIds(newDataIds)
              if (location.state?.listState) {
                const { products, first, rows } = location.state.listState;

                setProducts(products);
                setFirst(first);
                setRows(rows);
              } else {
                fetchData({
                  ...typeData,
                  limit: rows,
                  offset: 0
                });
              }
            }   
          })
          .catch(() => {
            errorMessage();
          })
          .finally(() => {
            setLoadingMore(false);
          });
  }

  useEffect(() => {

     getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
        }
      })
      .catch(() => errorMessage());
    
    getUsers(userData)
  }, []);

  // useEffect(() => {
  
  //     let startDate = "";
  //     let endDate = "";
  
  //     if (startDateValue) {
  //       startDate = new Date(startDateValue);
  //       endDate = endDateValue ? new Date(endDateValue) : new Date();
  //     }
  
  //     fetchData({
  //       ...typeData,
  //       limit: rows,
  //       offset: 0,
  //       recordType: recordTypeValue,
  //       startDate,
  //       endDate,
  //       leadTypeIn: [typeOfLead]
  //     });
  
  //   }, [recordTypeValue, typeOfLead, startDateValue, endDateValue]);

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: ["RECEIVE"],
      sourceIn: [],
      // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: ["RECEIVE"],
      // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
    });
  };

  const downloadPDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 40, 15);
    doc.setFontSize(16);
    doc.text("CA User Data", 200, 15);

    doc.autoTable({
      head: [["ID", "Date", "Name", "Mobile", "City", "State", "Status"]],
      body: data.map((item) => [
        item.id,
        formatDate(item.createdDate),
        item.name,
        item.mobile,
        item.city,
        item.state,
        item.status ? "ACTIVE" : "INACTIVE"
      ]),
      startY: 25,
      theme: "grid",
      styles: { fontSize: 9 }
    });

    doc.save("CA-User-List.pdf");
  };

  const handleLeadListUpload = (event) => {
    event.preventDefault();
    const fileInput = event.target.querySelector('input[type="file"]');
    const uploadFile = fileInput.files[0];

    if (!uploadFile) {
      console.error("No file selected");
      return;
    }

    LeadListUpload(uploadFile)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead List Upload Successfully " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData()
          setDisplayLeadListUpload(false);
        } else {
          errorMessage("Lead List Upload Failed " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData()
          setDisplayLeadListUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead List Upload Failed");
        setFileName("");
        setSelectedImage(null);
        fetchData()
        setDisplayLeadListUpload(false);
      });
  };

  const handleLeadAssignmentUpload = (event) => {
     
    event.preventDefault();

     const leadAssignedData = {
       lead: {
         id: assignedLeadId?.lead?.id
       },
       user: {
         id: assignedTelecallerId
       }
     }

     

    userLeadAssign(leadAssignedData)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead Assigned Successfully " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          fetchData({
            searchBy: "",
            searchText: "",
            limit: 20,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: ["RECEIVE"],
            sourceIn: [],
            // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
          });
          setDisplayLeadAssignmentUpload(false);
        } else {
          errorMessage("Lead Assigned Failed " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          fetchData({
            searchBy: "",
            searchText: "",
            limit: 20,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: ["RECEIVE"],
            sourceIn: [],
            // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
          });
          setDisplayLeadAssignmentUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead Assigned Failed");
        setAssignedTelecallerId("")
        setAssignedLeadId("")
        fetchData({
          searchBy: "",
          searchText: "",
          limit: 20,
          offset: 0,
          sortBy: "",
          sortOrder: "desc",
          statusIn: ["RECEIVE"],
          sourceIn: [],
          // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
        });
        setDisplayLeadAssignmentUpload(false);
      });
  };

  const handleLeadListDownload = () => {
    const link = document.createElement("a");
    link.href = "/bulk_Lead_upload.xlsx"; // File path inside public folder
    link.download = "bulk_Lead_upload.xlsx"; // Rename file on download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const renderDialogLeadUpload = () => (
    <Dialog
      header="Lead List Upload"
      visible={displayLeadListUpload}
      onHide={() => onHideLeadListUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleLeadListUpload}>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                onClick={handleLeadListDownload}
                style={{
                  padding: "10px",
                  background: "blue",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Download Sample File
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <label for="file-upload" className="custom-file-upload">
                  <i className="pi pi-upload"></i> Choose Lead List File
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <i
                  className="pi pi-file"
                  style={{ color: "blue", fontSize: "40px" }}
                ></i>
                {fileName && (
                  <p
                    style={{
                      alignSelf: "center",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 10,
                    }}
                  >
                    {fileName}
                  </p>
                )}
              </div>
            </div>
          </div>
          {selectedImage && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  const renderDialogLeadAssignmentUpload = () => (
    <Dialog
      header="Lead Assignment"
      visible={displayLeadAssignmentUpload}
      onHide={() => onHideLeadAssignmentUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleLeadAssignmentUpload}>
          <div className="row mb-3">
            <h6> {assignedLeadId?.lead?.name} Lead Assigned To </h6>
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
               
              <div className="col-md mb-2">
                <Dropdown
                  style={{ width: "100%" }}
                  options={userDataIds}
                  value={assignedTelecallerId}
                  onChange={(e) => {
                    setAssignedTelecallerId(e.value);
                  }}
                />
              </div>
            </div>
          </div>
          {assignedTelecallerId && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                
                  <div >
                    <h5 className="card-title flex">
                      <div
                      className="mr-3 cursor-pointer"
                        onClick={() => navigate("/")}
                      >
                        <i class="bi bi-arrow-left-circle-fill"></i>
                      </div> Lead List
                    </h5>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignSelf: "center" }}>
                    <div style={{ alignSelf: "center" }}>
                      <Link
                        to="/super-telecaller-lead-form-create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                    <div style={{ alignSelf: "center" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          marginRight: 10,
                          marginLeft: 10,
                        }}
                      >
                        <i
                          onClick={() =>
                            onClickLeadListUpload(
                              "displayLeadListUpload"
                            )
                          }
                          className="pi pi-upload"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>

                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>
                    {/*<div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={recordTypeSelection}
                        value={recordTypeValue}
                        placeholder="Select Record Type"
                        onChange={(e) => {
                          setRecordTypeValue(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={leadTypeList}
                        value={typeOfLead}
                        placeholder="Select Lead Type"
                        onChange={(e) => {
                          setTypeOfLead(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar 
                        value={startDateValue} 
                        onChange={(e) => {
                          const start = e.value;
                          setStartDateValue(start);

                          if (!endDateValue) {
                            setEndDateValue(new Date()); // default today
                          }
                        }}
                        dateFormat="dd/mm/yy" 
                        placeholder="Start Date"
                        maxDate={endDateValue ? endDateValue : new Date()}
                        showIcon
                        style={{ width: "100%" }} 
                        />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={endDateValue}
                        onChange={(e) => setEndDateValue(e.value)}
                        dateFormat="dd/mm/yy"
                        placeholder="End Date"
                        minDate={startDateValue}
                        showIcon
                        style={{ width: "100%" }} />
                    </div>*/}
                    {/*<div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={userDataIds}
                        value={selectedTelecallerId}
                        onChange={(e) => {
                          setSelectedTelecallerId(e.value);
                        }}
                      />
                    </div>*/}

                  </div>

                   
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      scrollable
                      scrollHeight="400px"
                      first={first}   // ✅ THIS FIXES YOUR ISSUE
                      onPage={(e) => setFirst(e.first)} // ✅ also required
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="View"
                        header="View"
                        className="product-category table-design"
                        body={(rowData) => (
                          <div className="action-cell">

                            <Link
                            to={"/super-telecaller-lead-form-create"}
                            state={{
                              rowData,
                              listState: {
                                products,
                                first,
                                rows
                              }
                            }}
                            className="move-btn-medium move-btn-yellow center-text"
                            >
                              View <i className="bi bi-pencil-square"></i>
                            </Link>

                            <div
                              className="act-btn act-call"
                              onClick={() => {
                                window.location.href = `tel:${rowData?.lead?.mobileNo}`;
                              }}
                            >
                              <i className="pi pi-phone"></i>
                            </div>

                            <a
                              href={`https://wa.me/91${rowData?.lead?.mobileNo}?text=${encodeURIComponent(
                                `Hello ${rowData?.lead?.name}, thank you for your interest.`
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="act-btn act-whatsapp"
                            >
                              <i className="pi pi-whatsapp"></i>
                            </a>
                          </div>

                        )}
                      ></Column>
                      <Column
                        field="assign"
                        header="Assign"
                        className="product-category table-design"
                        body={(rowData) => (
                          
                          <div
                            onClick={() =>
                              onClickLeadAssignmentUpload(
                                rowData
                              )
                            }
                            className="move-btn-medium move-btn-yellow center-text cursor-pointer"
                          >
                            Assign <i className="bi bi-fast-forward-btn-fill"></i>
                          </div>

                        )}
                      ></Column>
                      <Column
                        field="typeOfLead"
                        header="Type Of Lead"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.lead?.typeOfLead ? replaceUnderscoresWithSpacesAndUpperCase(rowData?.lead?.typeOfLead) : ""}

                          </span>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.status === "RECEIVE" ? "New Lead" : rowData.lead?.status}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="name"
                        header="Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.lead?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="mobileNo"
                        header="Mobile No"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.mobileNo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="address"
                        header="Address"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.address}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="amount"
                        header="Amount"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.amount?.toLocaleString("en-IN")}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="productInfo"
                        header="Product Info"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored6">
                            {rowData.lead?.productInfo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="queries"
                        header="Queries"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.queries}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="source"
                        header="Source"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.source}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="followUpOn"
                        header="Follow Up On"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.followUpOn}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="dateOfLead"
                        header="Date Of Lead"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData.lead?.dateOfLead)}
                          </span>
                        )}
                      ></Column>


                      
                      
                        {/*<Column
                          field="Doc"
                          header="Doc View"
                          className="product-category table-design"
                          body={(rowData) => (
                            <Link
                              to={"/view-lead-document"}
                              state={rowData?.lead}
                              className="move-btn-medium move-btn-green center-text"
                            >
                              Doc View <i className="bi bi-eye"></i>
                            </Link>
                          )}
                        ></Column>*/}

                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds} 
                    value={products} 
                    itemTemplate={itemTemplate} 
                    rows={5} 
                    loader 
                    // footer={footer} 
                    // header="Click Load Button at Footer to Load More" 
                  />
                  <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>{renderDialogLeadUpload()}</div>
      <div>{renderDialogLeadAssignmentUpload()}</div>
    </main>
  );
}
